export type DayFilter = "all" | "weekday" | "weekend" | number;

export type RoleFilter = "all" | "without-role" | (string & {});

export function filterByRole(
  filter: RoleFilter,
  assignedRoles: ReadonlyArray<{ readonly role: { readonly id: string } | null }>
) {
  if (filter === "all") {
    return true;
  }
  if (filter === "without-role") {
    return assignedRoles.length === 0;
  }
  return assignedRoles.some((r) => r.role?.id === filter);
}

export function filterDailyRoutines(
  filter: DayFilter,
  weekdays: Readonly<number>[]
) {
  if (filter === "all") {
    return true;
  }
  if (filter === "weekday") {
    return weekdays.some((d) => d <= 4);
  }
  if (filter === "weekend") {
    return weekdays.some((d) => d >= 5);
  }

  return weekdays.some((day) => day === filter);
}

export function dayFilterToDays(filter: DayFilter) {
  if (filter === "all") {
    return [0, 1, 2, 3, 4, 5, 6];
  }
  if (filter === "weekday") {
    return [0, 1, 2, 3, 4];
  }
  if (filter === "weekend") {
    return [5, 6];
  }
  return [filter];
}
